"use client";

import { memo, type ReactNode } from "react";
import { capitalizeFirstLetter } from "utils/utils";

interface FacetCheckboxProps {
  label: string;
  count: number;
  checked: boolean;
  disabled?: boolean;
  onToggle: (value: string | number, game?: string) => void;
  value: string | number;
  game?: string;
  icon?: ReactNode;
}

export const FacetCheckbox = memo(
  function FacetCheckbox({
    label,
    count,
    checked,
    disabled,
    onToggle,
    value,
    game,
    icon,
  }: FacetCheckboxProps) {
    return (
      <label
        className={`hover:bg-base-300 flex cursor-pointer items-center gap-2 rounded px-1 py-0.5 text-sm transition-colors ${
          disabled ? "pointer-events-none opacity-40" : ""
        }`}
      >
        <input
          type="checkbox"
          className="checkbox checkbox-xs checkbox-primary"
          checked={checked}
          disabled={disabled}
          onChange={() => onToggle(value, game)}
        />
        <span className="flex min-w-0 flex-1 items-center gap-1.5 truncate">
          {icon}
          {capitalizeFirstLetter(label)}
        </span>
        <span className="text-base-content/50 text-xs tabular-nums">
          {count}
        </span>
      </label>
    );
  },
  (prev, next) =>
    prev.checked === next.checked &&
    prev.count === next.count &&
    prev.label === next.label &&
    prev.disabled === next.disabled &&
    prev.value === next.value &&
    prev.game === next.game &&
    prev.onToggle === next.onToggle
  // icon deliberately excluded — deterministic per value
);
